var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"productForm",attrs:{"action":"/cart/add","method":"post","enctype":"multipart/form-data","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.addToCart.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }